import styled from 'styled-components';

export const DebugContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  flex-wrap: wrap;
  gap: 16px;

  position: relative;
  border: 1px solid ${({ theme }) => theme.kallisto.color.common.semantic.info[500]};
  color: ${({ theme }) => theme.kallisto.color.common.semantic.info[500]};
  border-radius: 8px;
  flex: none;
  background: ${({ theme }) => theme.kallisto.color.common.semantic.info[50]};
  padding: 16px;
  font-size: 14px;
  line-height: 24px;
  margin-bottom: 16px;

  a {
    text-decoration: underline;
  }
`;

export const DebugLink = styled.a`
  display: block;
  font-size: 14px;

  &:hover {
    text-decoration: underline;
  }
`;

export const DebugTracesLinkWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const BetaBadge = styled.sup`
  font-size: 0.65em;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  margin-left: 4px;
  vertical-align: super;
  opacity: 0.75;
`;

export const DebugInfoContainer = styled.div`
  width: 100%;
  @media (min-width: 768px) {
    text-align: right;
    width: auto;
  }
`;

export const DebugInfo = styled.div`
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  strong {
    font-weight: 600;
  }
`;
